import { useQuery } from '@tanstack/react-query';

import { fetchFopiCurrenciesData } from '../../api/portalGateway/fopiData';

export const useGetFopiCurrencyData = (fundId?: string) => {
  return useQuery({
    queryKey: ['fopi_currencies', fundId],
    queryFn: fetchFopiCurrenciesData,
  });
};
